"use_strict"

import { Polylang } from './components/Polylang'
import { Carousel } from './components/Carousel'
import { MainMenu } from './components/MainMenu'
import { MobileMenu } from './components/MobileMenu'
import { Searchbar } from './components/Searchbar'
import { NewsletterForm } from './components/NewsletterForm'
import { Toggle } from './components/Toggle'
import { ToggleTable } from './components/ToggleTable'
import { TopButton } from './components/TopButton'
import { Maps } from './components/Maps'
import { Animation } from './components/Animation'

class App {

	constructor () {
		const that = this

		// If carousel present, we init it
		let carousel = document.querySelector('.owl-carousel')
		if ( carousel ) this._carousel = new Carousel( carousel )

		// Init Polylang language selector
		this._polylang = new Polylang()

		// Init main menu keyboard and mouse behaviour
		this._mainMenu = new MainMenu()

		// Init mobile menu
		this._mobileMenu = new MobileMenu()

		// Init searchbar behaviour
		this._searchbar = new Searchbar()

		// Init newsletter form behaviour
		this._newsletterForm = new NewsletterForm()

		// Init top button
		this._topButton = new TopButton()

		// IniAnimation
		this._animation = new Animation()

		// Activate the smooth scrolling for anchors
		this._initAnchorsScrolling()

		this._initContactFormToggle()
		this._indicateNewWindowLink()

		this._initNewsletterFormCountrySelector()

		let isCorporatePage = document.body.classList.contains('page-template-tpl-corporate')
		if ( isCorporatePage ) this._initCorporateTablesToggle()

		let isExpertisePage = document.body.classList.contains('page-template-tpl-expertise')
		if ( isExpertisePage )
			this._map = new Maps()

		this._pageIsScrolled();

		window.onscroll = function () {
			that._pageIsScrolled();
		}
	}

	_pageIsScrolled () {
		if (window.scrollY > 0) {
			document.body.classList.add( 'scrolled' );
		} else {
			document.body.classList.remove( 'scrolled' );
		}
	}

	/**
	 * @function _initContactFormToggle
	 * @desc Init the button which opens/closes the contact form
	 */
	_initContactFormToggle () {
		const contactFormToggle  = document.getElementById('button-form-contact')
		const contactFormWrapper = document.getElementById('wrapper-form-contact')

		if ( contactFormToggle && contactFormWrapper ) {
			this._contactFormToggle = new Toggle( contactFormToggle, contactFormWrapper )
		}
	}

	/**
	 * @function _indicateNewWindowLink
	 * @desc Add a title with the mention "New window" to links opening a new window, except to links to documents in the page "corporate"
	 */
	_indicateNewWindowLink () {
		let links = document.querySelectorAll('a[target="_blank"]');
		let newWindowText = i18n.newWindow

		if ( links ) {
			links = Array.prototype.slice.call(links)
			links.forEach( link => {
				if ( link.classList.contains('table__link') ) return;

				let linkImage = link.getElementsByTagName('img')[0] || null;

				if ( linkImage ) {
					link.setAttribute( 'title', linkImage.alt + ' ' + newWindowText )
				} else {
					link.setAttribute( 'title', link.innerHTML + ' ' + newWindowText )
				}
			} )
		}
	}

	/**
	 * @function _initCorporateTablesToggle
	 * @desc TODO
	 */

	_initCorporateTablesToggle () {
		let buttonsOpeningTable = document.querySelectorAll('.js-corporate-table-opening')
		if ( buttonsOpeningTable ) {
		buttonsOpeningTable = Array.prototype.slice.call(buttonsOpeningTable)
			buttonsOpeningTable.forEach( buttonsOpeningTable => {
				let tableContainer = buttonsOpeningTable.nextElementSibling
				if ( tableContainer ) {
					let buttonClosingTable = tableContainer.querySelector('.js-corporate-table-closing')
					if ( buttonClosingTable ) {
						new ToggleTable( buttonsOpeningTable, buttonClosingTable, tableContainer )
					}
				}
			} )
		}
	}

	/**
	 * @function _initAnchorsScrolling
	 * @desc Activate scrolling for the anchir "Contact"
	 */

	_initAnchorsScrolling () {
		let $anchorsLinks = $("a[href*='#']:not([href='#'])");
		if ( !$anchorsLinks ) return;

		$anchorsLinks.on( 'click', function(e) {
			let $anchor = $( $(this).attr('href') );

			if ( $anchor ) {
				e.preventDefault();
				$( 'html, body' ).animate( { scrollTop: $anchor.offset().top }, 1500);
			}
		} );
	}

	_initNewsletterFormCountrySelector () {
		let newsletterForm = document.querySelector('div.mailpoet_form form');
		if (newsletterForm) {
			newsletterForm.removeAttribute('novalidate');
		}

	 	let textInput = document.querySelector('.mailpoet_text');
	 	if (textInput) {
	 		textInput.setAttribute('required', 'required');
	 	}

	 	let selector = document.querySelector('.mailpoet_select');
	 	if (selector) {
	 		selector.setAttribute('required', 'required');
			selector.addEventListener('change', function(e) {
		 		if (this.value == '') {
		 			this.classList.remove('has-value');
		 		} else {
		 			this.classList.add('has-value');
		 		}
		 	})
	 	}
	}
}

window.onload = () => {
	new App()
}
